import { reactive, readonly } from 'vue'

// The state of a feature tour (tours.ts). A tour moves between pages of two
// layouts with a full page load, so the state lives in sessionStorage: the
// tour, the stop, and the address of the question page the tour opens.

const STORAGE_KEY = 'gm_feature_tour'

type Saved = { tour: string; index: number; questionUrl: string }

const state = reactive({
  tour: '' as string,
  index: 0,
  questionUrl: '',
})

export const featureTour = readonly(state)

const save = () => {
  try {
    if (!state.tour) return sessionStorage.removeItem(STORAGE_KEY)
    const saved: Saved = { ...state }
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(saved))
  } catch {
    // No storage (a private window): the tour lives until the page changes.
  }
}

// The layouts call this after mount: the server renders no tour.
export const loadFeatureTour = () => {
  try {
    const saved = JSON.parse(
      sessionStorage.getItem(STORAGE_KEY) || 'null',
    ) as Saved | null
    if (!saved?.tour) return
    state.tour = saved.tour
    state.index = saved.index || 0
    state.questionUrl = saved.questionUrl || ''
  } catch {
    // A broken value is no tour.
  }
}

export const startFeatureTour = (tour: string) => {
  state.tour = tour
  state.index = 0
  save()
}

export const moveFeatureTour = (index: number) => {
  state.index = index
  save()
}

export const setFeatureTourQuestionUrl = (url: string) => {
  state.questionUrl = url
  save()
}

export const endFeatureTour = () => {
  state.tour = ''
  state.index = 0
  save()
}
